// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1I57d","infoBtn":"quickbooks_infoBtn__3fz8K","formBox":"quickbooks_formBox__N5Rvy","formFooter":"quickbooks_formFooter__3_7bU"};